import React, { useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import { reduxForm, Field } from "redux-form";
import { FormField } from "../../../sharedComponents/formField";

import PaginatedTable from "../../../sharedComponents/tableWithPagination";
import { getSummary } from "../../../store/actions";

export const Summary = ({ getSummary, summaryData }) => {
	useEffect(() => {
		getSummary();
	}, [getSummary]);

	const columns = [
		{ Header: "WEEK OF", accessor: "0", sortable: false },
		{ Header: "Monday", accessor: "1", sortable: false },
		{ Header: "Tuesday", accessor: "2", sortable: false },
		{ Header: "Wednesday", accessor: "3", sortable: false },
		{ Header: "Thursday", accessor: "4", sortable: false },
		{ Header: "Friday", accessor: "5", sortable: false },
		{ Header: "Saturday", accessor: "6", sortable: false },
		{ Header: "Sunday", accessor: "7", sortable: false },
		{ Header: "Total", accessor: "8", sortable: false }
	];

	const detailsFilterOptions = [
		{ name: "All history", id: "" },
		{ name: "Last 3 months", id: 30 },
		{ name: "Last 6 months", id: 180 },
		{ name: "Last 12 months", id: 360 }
	];

	const handleFilterDetails = (event) => {
		getSummary(event.target.value ? `?days_to_do=${event.target.value}` : "");
	};

	return (
		<React.Fragment>
			<div className=" d-flex justify-content-end">
				<Field
					name="days_to_do"
					type="select"
					formGroupClass="no-label summary-select-options"
					options={detailsFilterOptions}
					component={FormField}
					initialValues={0}
					onChange={(event) => handleFilterDetails(event)}
				/>
			</div>
			<PaginatedTable data={summaryData} columns={columns} />
		</React.Fragment>
	);
};

const mapDispatchToProps = { getSummary };

const mapStateToProps = (state) => {
	const { MyHistory } = state;
	return {
		summaryData: get(MyHistory, "summary.results", [])
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(
	reduxForm({
		form: "FilterDetails"
	})(Summary)
);
